import { z } from 'zod';

// Wire contract for the web-signup sponsor lookup on the eligibility API:
// `GET /api/v1/eligibility/sponsors/{clientId}` (which employer sent the
// member). The response schema is not `.strict()` (ADR-135 Rule 1: a
// client-parsed response tolerates new fields); the path params are strict.
// Program keys are opaque on the wire (ADR-015).

/** A signup link `client_id`: a positive integer, 1-9 digits, no leading zero. */
export const signupClientIdSchema = z.string().regex(/^[1-9][0-9]{0,8}$/);

export const signupSponsorParamsSchema = z.object({ clientId: signupClientIdSchema }).strict();
export type SignupSponsorParams = z.infer<typeof signupSponsorParamsSchema>;

export const signupSponsorFeaturesSchema = z.object({
  minorSupport: z.boolean(),
  spanish: z.boolean(),
  callChoice: z.boolean(),
  healthPlan: z.boolean(),
  multipleProgramSelection: z.boolean(),
  rewards: z.boolean(),
  languagePreference: z.boolean(),
  /**
   * Whether the sponsor's members book an onboarding call at the end of
   * signup. Absent means they do: an answer from a server that does not send
   * the field describes a sponsor with the call.
   */
  onboardingCall: z.boolean().optional(),
});
export type SignupSponsorFeatures = z.infer<typeof signupSponsorFeaturesSchema>;

export const signupSponsorSchema = z.object({
  clientRef: z.string().min(1),
  subClientRef: z.string().min(1).optional(),
  displayName: z.string().min(1),
  programKeys: z.array(z.string()),
  features: signupSponsorFeaturesSchema,
});
export type SignupSponsor = z.infer<typeof signupSponsorSchema>;
